import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';
import {
    type NodeCfg,
} from '../nodes';
import { functionalItem } from './functional-select.zod';

export const functionalInputsNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('functionalInputs'),
    controlValues: z.object({
        inputs: z.array(functionalItem),
    }),
});
export type FunctionalInputsNodeCfgSchema = z.infer<typeof functionalInputsNodeCfgSchema>;

export const functionalInputsNodeSocketCfg = {
    controlSockets: {
        inputs: () => ({}),
        outputs: () => ({
            start: 'event',
        }),
    },
    dataSockets: {
        inputs: () => ({}),
        outputs: (cfg: NodeCfg<'functionalInputs'>): Record<`output${number}`, 'string' | 'number' | 'boolean'> => {
            const ret = cfg.controlValues.inputs.reduce((acc, curr, i) => {
                acc[`output${i}`] = curr.dataType;
                return acc;
            }, {} as Record<`output${number}`, 'string' | 'number' | 'boolean'>);
            return ret;
        },
    },
} satisfies NodeSocketCfg<FunctionalInputsNodeCfgSchema>;
